import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function Timeline() {
  const phases = [{
    week: 'Semana 1',
    title: 'Desintoxicación y Alivio Inmediato',
    items: ['Eliminar gluten, lácteos A1, azúcar y aceites Omega-6', 'Ayuno fisiológico de 12 horas digestivas', 'Caldo de huesos diario para sellar el intestino', 'Día 4: el vientre empieza a deshincharse'],
    align: 'left'
  }, {
    week: 'Semana 2',
    title: 'Estabilización Hormonal',
    items: ['Crucíferas diarias para metabolizar el estrógeno', 'Regla proteína + fibra en cada comida', 'Tránsito intestinal diario obligatorio', 'Grasas esenciales para la progesterona'],
    align: 'right'
  }, {
    week: 'Semana 3',
    title: 'Regeneración y Consolidación',
    items: ['Apoyo hepático con alimentos metilantes', 'Sellado intestinal con glutamina y caldos largos', 'Movimiento restaurativo: yoga suave, caminatas', 'Preparación de la Regla 80/20 para mantener resultados'],
    align: 'left'
  }];
  return <section className="py-12 md:py-24 bg-[#143F35]" data-id="element-546">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-547">
        <div className="max-w-3xl mb-12 md:mb-20" data-id="element-548">
          <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-549">
            Capítulo 5 · El protocolo
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6 leading-tight" data-id="element-550">
            Tu mapa de ruta: <span className="italic text-peach" data-id="element-551">21 días</span>{' '}
            hacia un vientre libre de dolor
          </h2>
          <p className="text-sand/90 text-lg md:text-xl leading-relaxed" data-id="element-552">
            Tres semanas, tres fases de transformación. Cada una con un objetivo
            biológico preciso.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-553">
          {/* Center Line (hidden on mobile, visible on md+) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-peach/20 -translate-x-1/2" data-id="element-554"></div>

          <div className="space-y-8 md:space-y-24" data-id="element-555">
            {phases.map((phase, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: idx * 0.2
          }} className={`relative flex flex-col md:flex-row items-center ${phase.align === 'right' ? 'md:flex-row-reverse' : ''}`} data-id="element-556">
                {/* Content Card */}
                <div className={`w-full md:w-[45%] ${phase.align === 'right' ? 'md:pl-12' : 'md:pr-12'}`} data-id="element-557">
                  <div className="bg-[#1b2f28] border border-cream/10 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-558">
                    <span className="text-sand/60 text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-559">
                      {phase.week}
                    </span>
                    <h3 className="font-serif text-2xl md:text-3xl text-cream mb-6 md:mb-8" data-id="element-560">
                      {phase.title}
                    </h3>
                    <ul className="space-y-4" data-id="element-561">
                      {phase.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-sand/90" data-id="element-562">
                          <CheckCircle2Icon className="w-5 h-5 text-peach shrink-0 mt-0.5" data-id="element-563" />
                          <span className="leading-relaxed" data-id="element-564">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>

                {/* Center Circle */}
                <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-peach/90 text-forest font-serif text-2xl items-center justify-center shadow-[0_0_30px_rgba(232,160,122,0.3)] z-10" data-id="element-565">
                  {idx + 1}
                </div>
              </motion.div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}